import { lazyLoad } from 'utils/loadable';

export const RoleFormPage = lazyLoad(
  () => import('./index'),
  module => module.RoleFormPage,
);
